import memoize from 'memoizee';
import config from '@/constants/config';
import { arrayToHashmap, flattenArray } from '@/utils/Array';
import getFactoryV2Gauges from '@/utils/data/getFactoryV2Gauges';

const mainPoolsMainGaugesRewardsFn = {
    default: () => ({}),
};

const getSidechainAdditionalRewards = memoize(async () => {
    const [factoryV2Gauges, mainGaugesRewards] = await Promise.all([
        getFactoryV2Gauges(),
        (mainPoolsMainGaugesRewardsFn[config.blockchainId] || mainPoolsMainGaugesRewardsFn.default)(),
    ]);

    const factoGaugesRewards = arrayToHashmap(flattenArray(factoryV2Gauges.map(({ extraRewards }) => (
        extraRewards.map(({
            apy,
            gaugeAddress,
            tokenAddress,
            tokenPrice,
        }) => [`reward-${gaugeAddress.toLowerCase()}-${tokenAddress.toLowerCase()}`, {
            rewards: apy,
            price: tokenPrice,
        }])
    ))));

    return {
        ...factoGaugesRewards,
        ...mainGaugesRewards,
    };
}, {
    promise: true,
    maxAge: 10 * 60 * 0, // 10m
});

export default getSidechainAdditionalRewards;
